import { render, staticRenderFns } from "./MicroprotocolsManagerDialog.vue?vue&type=template&id=14160b4f&"
import script from "./MicroprotocolsManagerDialog.vue?vue&type=script&lang=js&"
export * from "./MicroprotocolsManagerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports